import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    component: () => import('../views/Login')
  },
  {
    path: '/demo',
    component: () => import('../views/demo')
  },
  {
    path: '/index',
    component: () => import('../components/TopMenu'),
    children: [
      //首页
      {
        path: '/home',
        component: () => import('../views/Home')
      },
      //设置
      {
        path: '/system',
        component: () => import('../views/SystemSetting/index')
      },
      //企业简介
      {
        path: '/companyprofile',
        component: () => import('../views/CompanyProfile/Home')
      },
      //能源管理
      {
        path: '/energymanagement',
        component: () => import('../views/EnergyManagement/Home')
      },
      //能源管理
      {
        path: '/securitymanagement',
        component: () => import('../views/SecurityManagement/Home')
      },
      //设备管理
      {
        path: '/devicemanagement',
        component: () => import('../views/DeviceManagement/Home')
      },
      //生产系统
      {
        path: '/productionsystem',
        component: () => import('../views/ProductionSystem/Home')
      },
      //销售系统
      {
        path: '/salessystem',
        component: () => import('../views/SalesSystem/Home')
      },
      //物流系统
      {
        path: '/iogisticssystem',
        component: () => import('../views/IogisticsSystem/Home')
      },
    ]
  },

  {
    path: "/",
    redirect: '/home'
  },
  {
    path: "*",
    redirect: '/home'
  },


  // {//登录
  //   path: '/',
  //   component:()=>import('../views/Login.vue'),
  // },
  // {//注册
  //   path:"/register",
  //   component:()=>import('../views/Register.vue')
  // },
  // {//找回密码
  //   path:"/findpwd",
  //   component:()=>import('../views/Findpwd.vue')
  // },
  // {
  //   path:"/",
  //   redirect:'/index/home'
  // },

]

const router = new VueRouter({
  routes
})

router.beforeEach(function (to, from, next) {//未登录拦截

  if (!localStorage.getItem('token')) {
    if (to.path != '/Login' ) {
      return next('/Login');
    }
  }

  next();
})


export default router
